import React, { useEffect, useState } from 'react';
import UploadDocPopUp from '../Documents/UploadDocPopUp';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';
import DocsGrid from '../Documents/DocsGrid';
import { setSeltSerchPat } from '../../redux/slices/patient/patientSlice';
import { useDispatch } from 'react-redux';

function PatientDocs({ patientId }) {
  const dispatch = useDispatch();
  const [allData, setAllData] = useState(null);
  const [docsName, setDocsName] = useState('');
  const [docsType, setDocsType] = useState('');
  const [docsStatus, setDocsStatus] = useState('');
  const [alocatToUser, setAlocatToUser] = useState('');
  const [provider, setProvider] = useState('');

  const [openAddEditPopup, setOpenAddEditPopup] = useState(false);

  const [reload, setReload] = useState(false);
  function handleReload() {
    setReload(!reload);
  }

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ManagePatientDocument/manageDocumentList',
          {
            patientId: patientId,
            docName: docsName,
            docType: docsType,
            status: docsStatus,
            reviewer: '',
            allocateTo: alocatToUser,
            provider: provider,
          }
        );
        if (response?.status === 200) {
          setAllData(response?.data);
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    })();
  }, [
    patientId,
    alocatToUser,
    docsName,
    docsStatus,
    docsType,
    provider,
    reload,
  ]);

  const handlePatDocsAddEditPopup = () => {
    dispatch(setSeltSerchPat({}));
    setOpenAddEditPopup(true);
  };

  return (
    <div className="docMaingrid-Pat">
      <div className="c-mid-bdy-hdr clear-top10">
        <span className="widget-hdr-title bold clear-top">Documents:</span>
        <span
          className="actn-yes"
          style={{ width: 'unset' }}
          onClick={handlePatDocsAddEditPopup}
        >
          Add New
        </span>
      </div>
      <div className="docMaingrid-Patbdy qgrid-sec" style={{ height: '400px' }}>
        <div className="docMaingrid-Pat-hdr grid-sec">
          <div className="docMaingrid-Pat-sbhdr flex-sec">
            <span className="colm3"></span>
            <span className="colm1">Doc Name</span>
            <span className="colm1">Type</span>
            <span className="colm2">Date</span>
            <span className="colm5">Status</span>
            <span className="colm4">Action</span>
            <span className="colm1">Reviewer</span>
            <span className="colm3 note-col">Note</span>
            <span className="colm3">Pages</span>
            <span className="colm1">Allocated to</span>
            <span className="colm1">Provider</span>
            <span className="colm2">Added</span>
          </div>
          <div className="docMaingrid-Pat-sbhdr flex-sec">
            <span className="colm3"></span>
            <span className="colm1">
              <input
                type="text"
                className="inpt-width-nw"
                value={docsName}
                onChange={(e) => setDocsName(e.target.value)}
              />
            </span>
            <span className="colm1">
              <select
                className="inpt-width-nw"
                value={docsType}
                onChange={(e) => setDocsType(e.target.value)}
              >
                <option value="">Select</option>
                {allData?.patientDistDocTypeArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm2"></span>
            <span className="colm5">
              <select
                className="inpt-width-nw"
                value={docsStatus}
                onChange={(e) => setDocsStatus(e.target.value)}
              >
                <option value="">Select</option>
                {allData?.statusList?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm4"></span>
            <span className="colm1"></span>
            <span className="colm3 note-col"></span>
            <span className="colm3"></span>
            <span className="colm1">
              <select
                className="inpt-width-nw"
                value={alocatToUser}
                onChange={(e) => setAlocatToUser(e.target.value)}
              >
                <option value="">Select</option>
                {allData?.assoUserArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm1">
              <select
                className="inpt-width-nw"
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
              >
                <option value="">Select</option>
                {allData?.assoUserArray?.map((item, i) => {
                  return (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  );
                })}
              </select>
            </span>
            <span className="colm2"></span>
          </div>
        </div>
        {allData?.documentDetailArr &&
          allData?.documentDetailArr?.map((item, i) => (
            <DocsGrid
              key={i}
              item={item}
              index={i}
              patientId={patientId}
              handleReload={handleReload}
            />
          ))}
      </div>
      {openAddEditPopup && (
        <UploadDocPopUp
          close={() => setOpenAddEditPopup(false)}
          patientId={patientId}
          handleReload={handleReload}
        />
      )}
    </div>
  );
}

export default PatientDocs;
